module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_16.8b688f35eb7103780039700e8b33d27a.png";